import { GridRow } from '@mui/x-data-grid-pro';
import type { GridRowProps } from '@mui/x-data-grid-pro';

import Tooltip from 'components/shared/Tooltip';
import { SummaryCard } from 'components/mrp/components/SummaryCard';

import type { EventResponse } from 'generated/index';

import { convertEventResponseToCalendarEvent } from './AppointmentRowTooltip.utils';

// The grid's row slot itself: the grid hands each row's appointment in as `row`.
const AppointmentRowTooltip = (gridRow: GridRowProps) => {
  'use memo';
  const event = gridRow.row as EventResponse | undefined;
  const calendarEvent = event
    ? convertEventResponseToCalendarEvent(event)
    : null;

  if (!calendarEvent) return <GridRow {...gridRow} />;

  return (
    <Tooltip
      arrow
      enterDelay={100}
      enterNextDelay={100}
      title={<SummaryCard event={calendarEvent} interactable={false} />}
    >
      <GridRow {...gridRow} />
    </Tooltip>
  );
};

export default AppointmentRowTooltip;
